"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerVerificationStatus = exports.ConsumerStatus = void 0;
var ConsumerStatus;
(function (ConsumerStatus) {
    ConsumerStatus["ACTIVE"] = "active";
    ConsumerStatus["BANNED"] = "banned";
})(ConsumerStatus = exports.ConsumerStatus || (exports.ConsumerStatus = {}));
var ConsumerVerificationStatus;
(function (ConsumerVerificationStatus) {
    ConsumerVerificationStatus["VERIFIED"] = "verified";
    ConsumerVerificationStatus["RETRY_ALLOWED"] = "retry";
    ConsumerVerificationStatus["REJECTED"] = "rejected";
    ConsumerVerificationStatus["PENDING"] = "pending";
    ConsumerVerificationStatus["MANUAL_CHECK_REQUIRED"] = "manual_check_required";
})(ConsumerVerificationStatus = exports.ConsumerVerificationStatus || (exports.ConsumerVerificationStatus = {}));
